'use strict'

const includes_ = require('lodash/includes')
const { roles: inputRoles } = require('./inputComponents')

module.exports = role => includes_(inputRoles, role)
